export default "mutation UpdateDevice($id: ID! $fields: deviceUpdateInput!) {\n  updateDevice(\n    id: $id,\n    fields: $fields\n  ) {\n    id\n  }\n}\n"